// extracted by mini-css-extract-plugin
export default {"tableWrapperContainer":"FinishDatePredictionCompletionPlan_tableWrapperContainer__cCD+d","pagination":"FinishDatePredictionCompletionPlan_pagination__O2QUU"};